<template>
<v-container grid-list-xl fluid>
    <v-layout row wrap>
        <v-flex lg12>
            <v-card>
                <hpo-filter :headers="headers" :viewName="viewName" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
                <v-data-table :headers="headers" :items="items" :options.sync="pagination" :server-items-length="total_rows" :footer-props="items_per_page" :must-sort="true" :loading="loading" :mobile-breakpoint="100">
                    <template v-slot:item="{ item }">
                        <tr>
                            <td>{{ item.ID }}</td>
                            <td>{{ item.Username }}</td>
                            <td class="text-end">{{ item.Amount | currency}}</td>
                            <td>{{ item.TradeContent }}</td>
                            <td v-bind:style="{ 'color': get_type_color(item.Status, recharge_status_list)}">{{ item.Status | display_value(recharge_status_list) }}</td>
                            <td>{{ item.CreatedDate | display_date }}</td>
                            <td>{{ item.CreatedBy }}</td>
                            <td class="text-center">
                                <v-icon medium class="mr-2" color="green darken-3" @click="gotoDetail(item.ID)" v-if="!csRole">visibility</v-icon>
                                <v-tooltip top v-if="adminRole">
                                    <template v-slot:activator="{ on }">
                                        <v-icon :disabled="item.Status !== 2" v-on="on" medium class="mr-2" color="red darken-6" @click="requestCancelRecharge(item.ID)">cancel</v-icon>
                                    </template>
                                    <span>Hủy lệnh nạp tiền</span>
                                </v-tooltip>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>
        </v-flex>
    </v-layout>
</v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "@/configs";
import Filtering from "@/components/Filtering";
import _ from "lodash";

export default {
    components: {
        "hpo-filter": Filtering
    },
    data() {
        let dataType = configs.DATA_TYPE;
        return {
            headers: [{
                    text: "ID",
                    value: "ID",
                    filterable: true,
                    dataType: dataType["Number"]
                },
                {
                    text: "User name",
                    value: "Username",
                    filterable: true,
                    quickSearch: true,
                    dataType: dataType["String"]
                },
                {
                    text: "Số tiền",
                    value: "Amount",
                    align: "end",
                    filterable: true,
                    dataType: dataType["Number"]
                },
                {
                    text: "Nội dung",
                    value: "TradeContent",
                    filterable: true,
                    dataType: dataType["String"]
                },
                {
                    text: "Trạng thái",
                    value: "Status",
                    filterable: true,
                    dataType: dataType["Enum"],
                    values: configs.RECHARGE_STATUS_LIST
                },
                {
                    text: "Ngày tạo",
                    value: "CreatedDate",
                    filterable: true,
                    dataType: dataType["Date"]
                },
                {
                    text: "Người tạo",
                    value: "CreatedBy",
                    filterable: true,
                    dataType: dataType["String"]
                },
                {
                    text: "Thao tác",
                    value: "",
                    align: "center",
                    sortable: false,
                    filterable: false
                }
            ],
            recharge_methods: configs.RECHARGE_METHODS,
            recharge_status_list: configs.RECHARGE_STATUS_LIST,
            recharge_status: configs.RECHARGE_STATUS,
            pagination: {...configs.PAGINATION},
            items_per_page: {...configs.ITEMS_PER_PAGE},
            viewName: "recharge_list",
            filterConditions: [],
            quickFilterConditions: [],
            dialogRecharge: false,
            requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
        };
    },
    watch: {
        pagination: {
            handler: function (val, oldVal) {
                let filterConditions = this.$store.state.commons.filterConditions;
                this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
                this.filter_data();
            },
            deep: true
        },
        loading() {
            this.$root.$emit('REQUEST_ROOT_OPTION', {invisibleExportButton: !this.adminRole && !this.paymentRole});
        }
    },
    computed: {
        ...mapState({
            items: state => state.rechargeHistory.all.data,
            total_rows: state => state.rechargeHistory.all.total,
            loading: state => state.rechargeHistory.loading,
            // recharge_summary: state => state.rechargeHistory.all.summary,
            currentRecharge: state => state.rechargeHistory.selected,
            // summary: state => state.report.financeReport.summary,
        }),
        adminRole() {
            return this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Admin;
        },
        paymentRole() {
            return this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Payment;
        },
        csRole() {
            return this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.CustomerService;
        },
    },
    methods: {
        filter_data: function () {
            var param = {
                pagination: this.pagination,
                filter: this.filterConditions,
                quickFilter: this.quickFilterConditions
            };
            this.$store.dispatch("rechargeHistory/getList", param);
        },
        gotoDetail: function (id) {
            let routeData = this.$router.resolve({
                name: "RechargeDetail",
                params: {
                Pid: id,
                title: `Chi tiết nạp tiền (#${id})`
                }
            });
            window.open(routeData.href, "_blank");
        },
        requestCancelRecharge(id) {
            window.getApp.$emit('REQUEST_DELETE_DATA', id, 'Bạn muốn hủy yêu cầu nạp tiền?');
        },
        cancelRecharge(rechargeId) {
            var selectedItem = _.find(this.items, {'ID': rechargeId});
            if(selectedItem) {
                selectedItem.Status = configs.RECHARGE_STATUS.Cancel;
                this.$store.dispatch("rechargeHistory/setDetail", {
                    data: {Status: configs.RECHARGE_STATUS.Cancel, Amount: selectedItem.Amount, UID: selectedItem.UID},
                    id: rechargeId,
                    cancel: true
                });
            }
        },
        applyFilter(filterConditions) {
            let sortBy = this.pagination.sortBy
            let sortDesc = this.pagination.sortDesc
            this.pagination = configs.PAGINATION;
            this.pagination.sortBy = sortBy;
            this.pagination.sortDesc = sortDesc;
            this.filterConditions = filterConditions;
            this.filter_data();
        },
        quickFilter(filterConditions) {
            this.quickFilterConditions = filterConditions;
            this.filter_data();
        },
        createData(username = '') {
            let routeData = this.$router.resolve({
                name: "RechargeNew",
            });
            window.open(routeData.href, "_blank");
        },
        get_type_color(val, enums) {
            return this.$options.filters.display_color(val, enums);
        },
        exportData() {
            var param = {
                pagination: this.pagination,
                filter: this.filterConditions,
                quickFilter: this.quickFilterConditions
            };
            this.$store.dispatch("rechargeHistory/exportList", param);
        }
    },
    mounted() {
        this.$root.$emit('REQUEST_ROOT_OPTION', {invisibleExportButton: !this.adminRole && !this.paymentRole});
        this.$root.$on("REQUEST_CREATE_DATA", this.createData);
        this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$on("CONFIRMED_REMOVE_DATA", id => {
            this.cancelRecharge(id);
        });
        this.$root.$on("REQUEST_EXPORT_ACTION", this.exportData);
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_CREATE_DATA", this.createData);
        this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$off("CONFIRMED_REMOVE_DATA");
        this.$root.$off("REQUEST_EXPORT_ACTION");
    }
};
</script>
